import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

import { ENV_CONFIG } from '../../config';
import { PATH } from '../../config';
import Common from '../../layout/common';
import storage from '../../service/storage';
import redirectHandler from '../../utils/redirect-handler';
import useAppStore from '../use-app';

const FeatureMyMochipass = dynamic(
  () => import('@autopass-web/feature-my-mochipass'),
  {
    ssr: false,
  },
);

const Mochipass = () => {
  const router = useRouter();
  const appStore = useAppStore();

  return (
    <Common
      navTop={{
        onClick: () => router.push(PATH.LICENSE_PLATES),
      }}
      backgroundColor="#f1f1f6"
      fullContent={true}
    >
      <FeatureMyMochipass
        app="client-mochipay"
        nextModule={true}
        basePath="/my-mochipass"
        env={{
          userId: appStore.me.id,
          analyticsKey: ENV_CONFIG.AMPLITUDE_KEY,
          accessToken: storage.getAuth().accessToken,
        }}
        action={{
          setRedirect: () =>
            redirectHandler.setLinks('/services?service=refueling&type=PASS'),
          push: (path) => router.push(path),
        }}
      />
    </Common>
  );
};

export default Mochipass;
